<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="subnetsDHCPv6"
      :items="subnetsDHCPv6"
      :fields="subnetsDHCPv6Fields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedSubnetsDHCPv6" :isEdit="isEdit"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: false,
      subnetsDHCPv6Fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'subnet', label: this.$i18n.t('Subnet'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedSubnetsDHCPv6: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedSubnetsDHCPv6 = {
        'client-class': '',
        'calculate-tee-times': true,
        'interface': '',
        'interface-id': '',
        'option-data': [],
        'pd-pools': [],
        'pools': [],
        'preferred-lifetime': 3000,
        'rapid-commit': false,
        'rebind-timer': 2000,
        'relay': {'ip-addresses': []},
        'renew-timer': 1000,
        'reservation-mode': 'all',
        'reservations': [],
        'subnet': '',
        't1-percent': 0.5,
        't2-percent': 0.8,
        'valid-lifetime': 4000
      }
      this.$root.$emit('bv::show::modal', 'modalEditSubnetsDHCPv6', '#btnShow')
    },
    editItem (item) {
      this.isEdit = true
      this.selectedSubnetsDHCPv6 = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditSubnetsDHCPv6', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Subnet DHCPv6"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let del = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      del.arguments.Dhcp6.subnet6 = del.arguments.Dhcp6.subnet6.filter((value) => {
        return value.id !== item.id
      })
      let DHCP = {
        'is_test_only': false,
        'loop_count_timeout': 35,
        'config': {}
      }
      DHCP.config = del.arguments
      let response = this.$store.dispatch('Settings/SAVE_DHCPV6', DHCP)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    subnetsDHCPv6 () {
      let numOptionData = 0
      let numPools = 0
      let numPdPools = 0
      let subnetsDHCPv6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let copy = subnetsDHCPv6.arguments.Dhcp6.subnet6
      for (let el of copy) {
        if (!el['interface-id']) {
          el['interface-id'] = ''
        }
        if (!el['client-class']) {
          el['client-class'] = ''
        }
        for (let elData of el['option-data']) {
          elData.numOptionData = ++numOptionData
        }
        for (let elPools of el.pools) {
          elPools.numPools = ++numPools
        }
        for (let elPdPools of el['pd-pools']) {
          elPdPools.numPdPools = ++numPdPools
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DHCPV6')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/DHCPv6/subnets/main.vue